// The app's navigation, in one place: the sidebar renders it and the top
// bar's breadcrumb reads it (ADR-49).

export type NavIcon = 'dashboard' | 'sources' | 'destinations' | 'pipelines' | 'runs' | 'notifications' | 'exports' | 'settings';

export interface NavItem {
  to: string;
  label: string;
  icon: NavIcon;
  badge?: 'failing' | 'unread';
}

export interface NavGroup {
  label: string;
  adminOnly?: boolean;
  items: NavItem[];
}

export const NAV: NavGroup[] = [
  { label: 'Overview', items: [{ to: '/dashboard', label: 'Dashboard', icon: 'dashboard' }] },
  {
    label: 'Data',
    items: [
      { to: '/sources', label: 'Sources', icon: 'sources' },
      { to: '/destinations', label: 'Destinations', icon: 'destinations' },
      { to: '/pipelines', label: 'Pipelines', icon: 'pipelines', badge: 'failing' },
      { to: '/runs', label: 'Run history', icon: 'runs' },
    ],
  },
  { label: 'Alerts', items: [{ to: '/notifications', label: 'Notifications', icon: 'notifications', badge: 'unread' }] },
  {
    label: 'Admin',
    adminOnly: true,
    items: [
      { to: '/exports', label: 'Exports', icon: 'exports' },
      { to: '/settings', label: 'Settings', icon: 'settings' },
    ],
  },
];

/** [group, page] for a path, e.g. ['Data', 'Run history'] for /runs. */
export function breadcrumbFor(pathname: string): [string, string] | null {
  for (const g of NAV) {
    for (const i of g.items) {
      if (pathname === i.to || pathname.startsWith(i.to + '/')) return [g.label, i.label];
    }
  }
  return null;
}
